import { memo, InputHTMLAttributes, forwardRef } from 'react';
import { StyledInput } from './simple-input.styled';
import { SpaceProps, TypographyProps } from 'styled-system';

export type Props = {
  //value: string,
  //variant: string
  error?: boolean;
} & SpaceProps &
  TypographyProps &
  InputHTMLAttributes<any>;

export const SimpleInput = memo(
  forwardRef<HTMLInputElement, Props>(({ ...props }, ref) => {
    return <StyledInput ref={ref} {...props} />;
  })
);
